import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CheckoutModal from "@/components/CheckoutModal";
import ProductCard from "@/components/ProductCard";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

export default function WishlistPage() {
  const { products, wishlist } = useCart();
  const { t } = useLanguage();
  const saved = products.filter((p) => wishlist.includes(p.id));

  return (
    <>
      <Nav />
      <main className="min-h-screen bg-page px-4 pb-10 pt-[132px] md:pt-[124px] lg:px-8" data-testid="wishlist-page">
        <div className="mx-auto max-w-7xl">
          <h1 className="flex items-center gap-2 text-2xl font-extrabold text-brandink" data-testid="wishlist-title">
            <Heart className="h-6 w-6 text-destructive" fill="currentColor" /> {t("wishlist_title")}
          </h1>
          {saved.length === 0 ? (
            <div className="mt-6 flex flex-col items-center gap-3 rounded-lg border border-line bg-white p-16 text-center" data-testid="wishlist-empty">
              <Heart className="h-10 w-10 text-muted" />
              <p className="text-sm font-semibold text-brandink">{t("wishlist_empty")}</p>
              <p className="text-xs text-muted">{t("wishlist_empty_sub")}</p>
              <Link
                to="/"
                data-testid="wishlist-start"
                className="mt-2 rounded-md bg-brand px-8 py-2.5 text-xs font-bold text-brandink transition-colors hover:bg-branddark"
              >
                {t("wishlist_start")}
              </Link>
            </div>
          ) : (
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5" data-testid="wishlist-grid">
              {saved.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
      <CartDrawer />
      <CheckoutModal />
    </>
  );
}
